module.exports = __webpack_public_path__ + "img/flag_target.5132fe08.png";